<template>
  <div class="team-report-intro-page">
    <div class="team-report-intro-page__intro">
      <i18n-t keypath="pdfReport.intropage_heading" :locale="lang" tag="h2"></i18n-t>
      <i18n-t keypath="pdfReport.intropage_description" :locale="lang" tag="p"></i18n-t>
    </div>
    <i18n-t keypath="pdfReport.intropage_subheading" :locale="lang" tag="h3"></i18n-t>
    <div class="concepts-wrapper">
      <div>
        <div class="concept-item">
          <p><i18n-t keypath="pdfReport.intropage_leadership_styles_heading" :locale="lang" tag="strong"></i18n-t></p>
          <i18n-t keypath="pdfReport.intropage_leadership_styles_description" :locale="lang" tag="div" class="concept-item__custom-text">
            <template #linebreak>
              <br/>
            </template>
          </i18n-t>
        </div>
        <div class="concept-item">
          <p><i18n-t keypath="pdfReport.intropage_leadership_objectives_heading" :locale="lang" tag="strong"></i18n-t></p>
          <i18n-t keypath="pdfReport.intropage_leadership_objectives_description" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
      <div>
        <div class="concept-item">
          <p><i18n-t keypath="pdfReport.intropage_manager_params_heading" :locale="lang" tag="strong"></i18n-t></p>
          <i18n-t keypath="pdfReport.intropage_manager_params_description" :locale="lang" tag="p"></i18n-t>
        </div>
        <div class="concept-item">
          <p><i18n-t keypath="pdfReport.intropage_max_spread_heading" :locale="lang" tag="strong"></i18n-t></p>
          <i18n-t keypath="pdfReport.intropage_max_spread_description" :locale="lang" tag="p"></i18n-t>
        </div>
        <div class="concept-item">
          <p><i18n-t keypath="pdfReport.intropage_characteristic_styles_heading" :locale="lang" tag="strong"></i18n-t></p>
          <i18n-t keypath="pdfReport.intropage_characteristic_styles_description" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
    </div>

    <div class="intro-tip">
      <p>
        <i18n-t keypath="pdfReport.intropage_tip" :locale="lang" tag="strong"></i18n-t> <i18n-t keypath="pdfReport.intropage_tip_description" :locale="lang" tag="span"></i18n-t>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lang: ''
  }
}
</script>

<style scoped>
* {
  letter-spacing: initial!important;
}
h2 {
  font-size: 20px!important;
  margin: 0 0 4px 0!important;
  padding: 0!important;
  color: #000000;
}
h3 {
  font-size: 14px!important;
  margin: 12px 0 6px 0!important;
  padding: 0!important;
  color: #000000;
}
p,
p strong,
p span {
  font-size: 10px!important;
  margin: 0!important;
  padding: 0!important;
  max-width: 460px;
  color: #000000;
}
.team-report-intro-page {
  padding: 0 60px;
}
.team-report-intro-page__intro {
  width: 460px;
}
.concepts-wrapper {
  display: flex;
  width: 460px;
  justify-content: space-between;
}
.concept-item:not(:last-child) {
  margin-bottom: 10px;
}
.concept-item__custom-text {
  font-size: 10px!important;
  margin: 0!important;
  padding: 0!important;
  max-width: 460px;
  color: #000000;
}
.concepts-wrapper > div {
  width: 220px;
}
.intro-tip {
  border-radius: 8px;
  background-color: #F4F4F4;
  padding: 10px 12px;
  margin-top: 20px;
  width: 460px;
}
</style>
